import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { RootState } from '../store/store';
import { clearUser } from '../store/userSlice';

// Raw base query to attach auth headers
const rawBaseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.BASE_URL || '/'}api`,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).user.jwtToken || localStorage.getItem('token');
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

// Wrapper to handle 401 globally
const baseQueryWithAuthHandling: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  if (result && 'error' in result && result.error && result.error.status === 401) {
    try {
      localStorage.removeItem('token');
    } catch { }
    api.dispatch(clearUser());
    // Optional: redirect to login if you're on a protected route
    // window.location.assign('/login');
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuthHandling,
  endpoints: () => ({}),
  tagTypes: [
    'User',
    'AMC',
    'Asset',
    'MerchantConfig',
    'PaymentConfig',
    'Payment',
    'PaymentLog',
    'PaymentType',
    'Aggregator',
    'Transaction',
    'BankDetails',
    // Additional tags used by injected endpoints
    'PaymentDetailsResponse',
    'PaymentLogsResponse',
    'PaymentTypeBreakdownResponse',
    'AggregatorTypeBreakdownResponse',
    'TransactionCountStatusResponse',
    'TransactionCountPaymodeResponse',
    'PaymentSuccessRateComparisonResponse',
    'GatewayExclusion',
    'SwiftFlowError',
  ],
});
